import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingButton from "../../components/Loading/LoadingButton";
import { postMethod } from "../../function/helper";
import style from "./WebService.module.css";
import webServiceSchema from "./components/webServiceSchema";
import useSharedData from "../../hooks/useSharedData";

function WebServiceForm() {
  const { user, isAuthed } = useSharedData();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(webServiceSchema),
  });

  const { isPending, mutate } = useMutation({
    mutationKey: ["web-service-form"],
    mutationFn: data =>
      postMethod("/avaexApi/request/new", data).then(res => {
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            text: res.data.message,
            showConfirmButton: true,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "green",
          });
          reset();
          return res.data.result;
        } else {
          Swal.fire({
            icon: "error",
            text: res ? res.data.message : "عملیات با خطا مواجه شد",
            showConfirmButton: true,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "gray",
          });
        }
      }),
  });

  useEffect(() => {
    if (user) {
      setValue("name", user.name);
      setValue("family", user.family);
      setValue("mobile", user.phone);
      setValue("id", user.id);
    }
  }, []);

  return (
    <Container className="rtl-dir my-5">
      <h4>فرم درخواست وب سرویس (API)</h4>

      <form onSubmit={handleSubmit(mutate)}>
        <section className={"gridBox mt-4 " + style.box}>
          <article>
            <Form.Label>نام:</Form.Label>
            <Form.Control disabled={isAuthed} {...register("name")} />
            {errors.name !== undefined && <p>{errors.name.message}</p>}
          </article>

          <article>
            <Form.Label>نام خانوادگی:</Form.Label>
            <Form.Control disabled={isAuthed} {...register("family")} />
            {errors.family !== undefined && <p>{errors.family.message}</p>}
          </article>

          <article>
            <Form.Label>شماره همراه:</Form.Label>
            <Form.Control disabled={isAuthed} {...register("mobile")} />
            {errors.mobile !== undefined && <p>{errors.mobile.message}</p>}
          </article>

          <article>
            <Form.Label>تلفن ثابت:</Form.Label>
            <Form.Control {...register("phone")} />
            {errors.phone !== undefined && <p>{errors.phone.message}</p>}
          </article>

          <article>
            <Form.Label>آدرس وب سایت:</Form.Label>
            <Form.Control {...register("webSiteAddress")} />
            {errors.webSiteAddress !== undefined && (
              <p>{errors.webSiteAddress.message}</p>
            )}
          </article>

          <article>
            <Form.Label>نوع کسب و کار:</Form.Label>
            <Form.Control {...register("businessType")} />
            {errors.businessType !== undefined && (
              <p>{errors.businessType.message}</p>
            )}
          </article>

          <article className="grid-line">
            <Form.Label>توضیحات:</Form.Label>
            <Form.Control
              as="textarea"
              className="bg-white"
              {...register("description")}
            />
            {errors.description !== undefined && (
              <p>{errors.description.message}</p>
            )}
          </article>

          <article className="grid-line">
            {isPending && (
              <LoadingButton className="btn-success" title="در حال ثبت" />
            )}
            {isPending === false && (
              <Button type="submit" className="btn-success">
                ثبت
              </Button>
            )}
          </article>
        </section>
      </form>
    </Container>
  );
}

export default WebServiceForm;
